export default "__VITE_ASSET__$AYRvY3O__"